import React from 'react';
import ReactGA from 'react-ga';

import { Page } from '../components';
import { FormContent, PrimaryContent } from '../components/Content/AddressScreen';

ReactGA.pageview(window.location.pathname + window.location.search);

const AddressScreen = () => (
  <Page id="main">
    <PrimaryContent />
    <FormContent />
  </Page>
);

export default AddressScreen;
